// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1K8qP","itemTitle":"ClientEmergencyInfo_itemTitle__3l3Rb","itemText":"ClientEmergencyInfo_itemText__1r30n"};